import { AxiosRequestConfigWithUUID } from 'src/api';
import { createRequestHash } from 'src/services/requestHashService';
import CryptoJS from 'crypto-js';
import { generateEncryptedTotp, getRequestLoginSecret, hashSecret } from './getTotp';
import { getPathOnly } from '../getPathOnly';


type BuildLoginHeadersResult = {
    headers?: {
        'X-TOTP': string;
        'X-Request-Signature': string;
    };
    error?: string;
};

export function uint8ArrayToWordArray(u8: Uint8Array): CryptoJS.lib.WordArray {
    const hex: string[] = [];

    for (let i = 0; i < u8.length; i++) {
        hex.push(u8[i].toString(16).padStart(2, '0'));
    }

    return CryptoJS.enc.Hex.parse(hex.join(''));
}

export const buildLoginHeaders = async (
    config: AxiosRequestConfigWithUUID
): Promise<BuildLoginHeadersResult> => {
    const uuid = config.uuid;

    if (!uuid) {
        return { error: 'Missing uuid' };
    }

    const keySecret = getRequestLoginSecret(uuid);
    const requestKey = await hashSecret(keySecret);

    const totpResult = await generateEncryptedTotp(uuid);

    if (!totpResult.success) {
        return { error: totpResult.error || 'Failed to generate encrypted TOTP' };
    }

    const encryptedTotp = totpResult.data;

    const path = getPathOnly(config.url);
    const method = (config.method || 'POST').toUpperCase();

    let body = '';
    if (typeof config.data === 'string') {
        body = config.data;
    } else if (config.data) {
        body = JSON.stringify(config.data);
    }

    const requestSignature = createRequestHash(
        uint8ArrayToWordArray(requestKey),
        method,
        path,
        body,
        ''
    );

    return {
        headers: {
            'X-TOTP': encryptedTotp,
            'X-Request-Signature': requestSignature,
        },
    };
};